module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-4-61e04e6f2f4840443c077b4c731dbbc9.webp";